import { Box } from "@mui/material";
import { Input, SectionDivider } from "../..";
import { useTranslation } from "react-i18next";
import { useStyles } from "./style";
import { User } from "../../../types";

interface DetailsProps {
  account: User | null;
  formData: { [key: string]: string };
  handleChange: (field: string, value: string) => void;
}

export const Details = ({ account, formData, handleChange }: DetailsProps) => {
  const { t } = useTranslation();

  const nameParts = formData.name ? formData.name.split(" ") : ["", ""];
  const firstName = nameParts[0];
  const lastName = nameParts.slice(1).join(" ");

  // Handle onChange for both firstName and lastName
  const handleFirstNameChange = (value: string) => {
    handleChange("name", `${value} ${lastName}`);
  };

  const handleLastNameChange = (value: string) => {
    handleChange("name", `${firstName} ${value}`);
  };

  const classes = useStyles();
  return (
    <Box className={classes.container}>
      <Input
        label={t("accountDetails.apaSerial")}
        placeholder="APA-123-456-11"
        required
        value={formData.apaSerial}
        onChange={(value) => handleChange("apaSerial", value)}
      />

      <SectionDivider label={t("accountDetails.owner")} />

      <Input
        label={t("accountDetails.email")}
        required
        placeholder={t("accountDetails.emailPlaceholder")}
        value={formData.email}
      />
      <Box className={classes.rowWrapper}>
        <Input
          label={t("accountDetails.firstName")}
          required
          value={firstName}
          onChange={handleFirstNameChange}
        />
        <Input
          label={t("accountDetails.lastName")}
          required
          value={lastName}
          onChange={handleLastNameChange}
        />
      </Box>

      <Input
        label={t("accountDetails.phone")}
        value={formData.phone}
        onChange={(value) => handleChange("phone", value)}
      />
    </Box>
  );
};
